import { resetButtonStyle, BodyLinkStyle } from '@kvdbil/components';
import React, { ReactNode, MouseEventHandler } from 'react';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';

const Button = styled.button`
  ${resetButtonStyle};
  ${BodyLinkStyle};
  color: ${({ theme }) => theme.colors.grayscaleToned.dark3};

  &:focus-visible {
    outline: revert;
  }
`;

interface Props {
  children: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

const CookiesButtonLink = ({ children, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <Button onClick={onClick} aria-label={t('Change your cookie settings')}>
      {children}
    </Button>
  );
};

export default CookiesButtonLink;
